import { useState, useCallback } from 'react';

export const useFilterState = ({ gridApiRef, panelLabel, onFilterChanged }) => {
  const [filteredData, setFilteredData] = useState([]);
  const onGridFilterChanged = useCallback(
    (params) => {
      if (!gridApiRef.current || !panelLabel) return;

      const newFilteredData = [];
      gridApiRef.current.forEachNodeAfterFilterAndSort((node) => {
        // Full-width MasterDetail rows are clones of the master; keep them out of panel counts.
        if (node.data?._isDetail) {
          return;
        }
        newFilteredData.push(node.data);
      });
      setFilteredData(newFilteredData);
      onFilterChanged?.(params); // this is not grid api, and we should not call it(as it is not a grid api) here
    },
    [panelLabel, onFilterChanged]
  );

  return {
    filteredData,
    onGridFilterChanged
  };
};
